import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  WAHA_STATUS_MANAGE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import WahaStatusIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/waha-status'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'waha_status_index',
          component: WahaStatusIndex,
          meta: {
            permissions: [ROLES[1], WAHA_STATUS_MANAGE_PERMISSIONS],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
